'use strict';

import * as dom from './lib/dom.js';

function followScroll() {
	const singleEl = document.querySelector('.c-single');
	const singleEpecialEl = document.querySelector('.single-special');
	const displayWidth = window.innerWidth;

	if (singleEl && displayWidth >= 1024 && !singleEpecialEl) {
		const header = document.querySelector('header');
		const headerHeight = header.offsetHeight;
		const mainContent = document.querySelector('.c-content-shield__main');
		const mainContentHeight = mainContent.offsetHeight;
		const mainContentWidth = mainContent.offsetWidth;

		const bigBannerAside =  document.querySelector('.o-slot-content--big');
		const bigBannerAsideHeight = bigBannerAside.offsetHeight;
		const bigBannerAsideEndOffset = dom.getPosition(bigBannerAside).y + bigBannerAsideHeight + window.scrollY;
		const bigBannerAsideStartOffset = dom.getPosition(bigBannerAside).y + window.scrollY;
		let lastBigBannerAsideStartOffset = bigBannerAsideStartOffset;

		const aside = document.querySelector('.c-single__side-content');
		const asideHeight = aside.offsetHeight;
		const mainContentStartOffset = dom.getPosition(mainContent).y + window.scrollY;
		const mainContentEndOffset = dom.getPosition(mainContent).y + mainContentHeight + window.scrollY;
		const asideEndOffset = dom.getPosition(aside).y + asideHeight + window.scrollY;
		const asideStartOffset = dom.getPosition(aside).y + window.scrollY;
		let lastAsideStartOffset = asideStartOffset;

		const alsoRead = document.querySelector('.c-also-read');
		const alsoReadHeight = alsoRead.offsetHeight;

		// console.log(alsoRead);

		if (bigBannerAsideHeight < 300) {
			if(window.pageYOffset > (mainContentStartOffset - headerHeight) && window.pageYOffset < (mainContentEndOffset - asideHeight - 75)) {
				aside.style.position = 'fixed';
				aside.style.top = '75px';
				aside.style.right = 'auto';
			   	aside.style.marginLeft = mainContentWidth + 1 + 'px';

			} else if (window.pageYOffset > (mainContentEndOffset - asideHeight - 75)) {

		   		aside.style.position = 'absolute';
				aside.style.top = mainContentHeight - asideHeight + 'px';
				aside.style.right = '0px';
			   	aside.style.marginLeft = '0px';
		 	}  else {
		 		aside.style.position = 'absolute';
		   		aside.style.marginLeft = 0;
		   		aside.style.right = '0px';
		   		aside.style.top = '0px';
		 	}
		}

		else {

			if (asideHeight > mainContentEndOffset - asideHeight) {
				aside.style.position = 'relative';
			} else {
				if(window.pageYOffset > (mainContentStartOffset - headerHeight) && window.pageYOffset < (mainContentEndOffset - asideHeight - 75)) {
				aside.style.position = 'fixed';
				aside.style.top = '75px';
				aside.style.right = 'auto';
			   	aside.style.marginLeft = mainContentWidth + 1 + 'px';

				} else if (window.pageYOffset > (mainContentEndOffset - asideHeight - 75)) {

			   		aside.style.position = 'absolute';
					aside.style.top = mainContentHeight - asideHeight + 'px';
					aside.style.right = '0px';
				   	aside.style.marginLeft = '0px';
			 	}  else {
			 		aside.style.position = 'absolute';
			   		aside.style.marginLeft = 0;
			   		aside.style.right = '0px';
			   		aside.style.top = '0px';
			 	}
			}
		}
		// } else {

		//  	if(window.pageYOffset > (mainContentStartOffset - headerHeight) && window.pageYOffset < (mainContentEndOffset - bigBannerAsideHeight - alsoReadHeight - 75)) {
		//  		console.log('entrou');
		//  		bigBannerAside.classList.remove('o-slot-content--big-end');
		//  		bigBannerAside.classList.remove('o-slot-content--big-out');
		// 		bigBannerAside.classList.add('o-slot-content--big-start');
		// 		alsoRead.classList.add('c-also-read--bottom');
		// 		aside.classList.add('c-single__side-content--big-banner');

		// 	} else if (window.pageYOffset > (mainContentEndOffset - bigBannerAsideHeight - alsoReadHeight - 75)) {
		// 		console.log('entrou 2');
		// 		bigBannerAside.classList.remove('o-slot-content--big-out');
		// 		bigBannerAside.classList.remove('o-slot-content--big-start');
		// 		bigBannerAside.classList.add('o-slot-content--big-end');

		// 		bigBannerAside.style.top = mainContentHeight - bigBannerAsideHeight - alsoReadHeight - 15 + 'px';

		//  	}  else {
		//  		bigBannerAside.classList.add('o-slot-content--big-out');
		//  		alsoRead.classList.add('c-also-read--bottom');
		// 		aside.classList.add('c-single__side-content--big-banner');
		//  	}
		//  }

	 	// console.log(asideEndOffset);
	 	// console.log(mainContentStartOffset);


	}
}

export default function(){

	window.addEventListener('resize', function() {
        followScroll();
  	});

	window.addEventListener('scroll', function() {
	    followScroll();
	});
}
